import { AppTour } from '../tour.model';

export const SETUP_FUNCTION_TOUR: AppTour = {
  tourId: 'setup-function-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_start_title",
      text: 'tour_self_setup_start_text',
      buttons: [
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

  export const SETUP_EXPENSE_CATEGORY_TOUR: AppTour = {
  tourId: 'setup-expense-category-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_catgeory_title",
      text: 'tour_self_setup_catgeory_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

export const SETUP_TAX_TOUR: AppTour = {
  tourId: 'setup-tax-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_tax_rates_title",
      text: 'tour_self_setup_tax_rates_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

  export const SETUP_MILEAGE_TOUR: AppTour = {
  tourId: 'setup-mileage-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_mileage_title",
      text: 'tour_self_setup_mileage_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

export const DAILY_LIMIT_POLICY_TOUR: AppTour = {
  tourId: 'daily-limit-policy-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_daily_policy_title",
      text: 'tour_self_setup_daily_policy_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

  export const REPORT_WRITER_TOUR: AppTour = {
  tourId: 'report-writer-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_report_writer_title",
      text: 'tour_self_setup_report_writer_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};

  export const INTEGRATIONS_TOUR: AppTour = {
  tourId: 'integrations-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#self-setup_container-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: "tour_self_setup_integrations_title",
      text: 'tour_self_setup_integrations_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_go_to_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};